import React from 'react'
import {NullAsDefault} from 'views/Shared'
import getTitle from "../../../../helpers/getTitle";
import classNames from "classnames";
import {renderIf, renderIfElse} from "../../../Shared";
import _ from "lodash";
import {formatDate, renderFromToTime} from "../../../../helpers/datetimeHelpers";

export const renderSubjectResultItem = ({translate: t, renderActions = NullAsDefault} = {}) => (item, index) => {

    const {subject, course_class, result_date, result_status, notes, score_type, score_text, score_number} = item ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <div key={index}
             className="p-3 flex flex-col gap-1 border border-color-50 hover:border-color-100 hover:shadow-md rounded-xl relative">
            <div className="font-semibold text-sm text-color-000 tracking-wide">
                {getTitle(subject)}
            </div>
            <div className="grid grid-cols-2 gap-1">
                {renderIf(
                    _.some([score_text, score_number > 0]),
                    <div className="space-x-1 text-xs italic">
                        <span className="text-color-400">{`${t('score')} : `}</span>
                        <span className="font-medium text-color-100">
                            {renderIfElse(
                                score_type === 'text',
                                score_text,
                                score_number
                            )}
                        </span>
                    </div>
                )}
                {result_date && (
                    <div className="space-x-1 text-xs italic">
                        <span className="text-color-500">
                            {`${t('result date')} : `}
                        </span>
                        <span className="font-medium text-color-100">
                            {formatDate(result_date, 'DD/MM/YYYY')}
                        </span>
                    </div>
                )}
            </div>
            <span className="space-x-1 text-xs text-color-400 italic">
                <span>{t('learn in the class')}</span>
                <span className="font-semibold text-slate-600">
                    {getTitle(course_class)}
                </span>
                <span>{t('in the course')}</span>
                <span className="font-semibold text-slate-600">
                    {getTitle(course_class?.course)}
                </span>
                {(course_class?.from_date || course_class?.to_date) && (
                    <span className="font-medium text-color-300 lowercase">
                        ({renderFromToTime(course_class?.from_date, course_class?.to_date)})
                    </span>
                )}
            </span>
            {renderIf(
                notes,
                <span className="space-x-1 text-xs italic">
                    <span className="font-bold text-color-100">{`* ${t('note')} : `}</span>
                    <span className="text-color-300">{notes}</span>
                </span>
            )}
            {renderIf(
                result_status !== null,
                <span
                    style={{position: 'absolute', top: 10, right: 10}}
                    className={classNames('font-bold text-xs tracking-wide uppercase opacity-75', color_status)}>
                    {t(label_status)}
                </span>
            )}
            {renderActions(item)}
        </div>
    )
}
